/**
 * Elite-only sell landing (mirrors `/elite-prime-landing` with Elite locked).
 *
 * Belongs here: Elite-locked sell body with no plan switcher.
 * Does not belong here: dual-tab sell (`/elite-plans`) or Elite dashboard.
 */
import '../elitePlansTheme.css'
import {
  ELITE_PLANS_ELITE_TAB_ID,
  ElitePlansLandingProvider,
  useElitePlansLanding
} from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ELITE_LANDING_STATUS_QUERY_KEY } from '../constants/queryKeys'
import { ElitePlansSellLandingChrome } from '../components/ElitePlansSellLandingChrome'
import { ElitePrimeDashboardHeader } from '../components/ElitePrimeDashboardHeader'
import { ElitePlansSellBody } from '../components/ElitePlansSellBody'
import { useTrackElitePlansScreenLoadWhenReady } from '../hooks/useTrackElitePlansScreenLoadWhenReady'

export default function ElitePlansEliteLandingPage() {
  return (
    <ElitePlansLandingProvider
      analyticsScreen={ElitePlansAnalyticsScreen.EliteLanding}
      lockedPlanId={ELITE_PLANS_ELITE_TAB_ID}
      statusQueryKeyRoot={ELITE_LANDING_STATUS_QUERY_KEY}
    >
      <ElitePlansEliteLandingPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePlansEliteLandingPageContent() {
  const { isStatusLoading } = useElitePlansLanding()
  useTrackElitePlansScreenLoadWhenReady(!isStatusLoading)

  return (
    <ElitePlansSellLandingChrome>
      <ElitePrimeDashboardHeader accent='elite' showPlanTab={false} />
      <ElitePlansSellBody />
    </ElitePlansSellLandingChrome>
  )
}
